import { render, staticRenderFns } from "./AddClinicalExposureModal.vue?vue&type=template&id=9d5e7406&scoped=true&"
import script from "./AddClinicalExposureModal.vue?vue&type=script&lang=js&"
export * from "./AddClinicalExposureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5e7406",
  null
  
)

export default component.exports